import React, {useEffect, useState} from "react";
import styled from "styled-components";
import logo from "../../assets/images/logo-white.png";
import fond from "../../assets/images/fond_1.png";
import hom from "../../assets/images/homme-mobile.png";
import ill from "../../assets/images/Illustration-personnages-timed.png"
import {LoginFormMobile} from "./LoginForm/LoginFormMobile";
import {useLocation} from "react-router-dom";
import {version_annoncee} from "../../version";
import {z} from "framer-motion/dist/types.d-6pKw1mTI";

interface LoginMobileCtrlProps{
    className?:string;
}

const LoginMobileCtrl = ({className}:LoginMobileCtrlProps)=>{
    const location = useLocation();
    const [full, setFull] = useState(false);
    return (
        <div className={`MobileLogin ${className}`}>
            <div className={`version`}>{version_annoncee}</div>
            <div className="content_log">
                <div className="in_content">
                    <div className="wrap_img">
                        <img src={ill} alt={"Timed mobile"}/>
                    </div>
                    <div className={`form-content`}>
                        <LoginFormMobile setFull={setFull} location={location}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

const LoginMobile = styled(LoginMobileCtrl)`
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .content_log{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .wrap_img {
        width: 70%;
        margin: 30px auto;

        img{
            width: 100%;
        }
    }
  .form-content{
    h1{
      padding-left: 2rem;
    }
  }
  .version{
    font-size: 10px;
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
  h1{
    margin-bottom: 20px;
  }
  .form-content{
    padding: 1rem 2rem;
  }
  .content-front{
    z-index: 1;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .homme-place{
      flex-grow: 1;
      text-align: center;
      position: relative;
      &.scaler{
        img{
          transform: translate(-50%,-50%) scale(1.3);
        }
      }
      img{
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%,-50%);
        width: 40%;
        transition: all 0.3s;
      }
    }
    .logo-place{
      text-align: center;
      padding: 1rem;
      height: 80px;
      margin-top: 80px;
      img{
        height: 60%;
        width: auto;
      }
    }
  }
  .logo-place{
    
  }
  .block-head{
    width: 100%;
    position: relative;
    transition: height 0.4s;
    .content-fond{
      left: 0;
      top: 0;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      z-index: 1;
      width: 100%;
      height: 100%;
      .img{
        position: absolute;
        bottom: 0;
      }
    }
  }
`

export default LoginMobile;
